import { render, staticRenderFns } from "./DescriptionItem.vue?vue&type=template&id=39fb5748&scoped=true&"
import script from "./DescriptionItem.vue?vue&type=script&lang=js&"
export * from "./DescriptionItem.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionItem.vue?vue&type=style&index=0&id=39fb5748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fb5748",
  null
  
)

export default component.exports